import { Link, useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark shadow-sm fixed-top py-3" style={{ backgroundColor: 'var(--primary-color)' }}>
      <div className="container">
        {/* LOGO */}
        <Link className="navbar-brand d-flex align-items-center fw-bold fs-3" to="/">
          <i className="bi bi-heart-pulse-fill me-2"></i>
          FITNOVA
        </Link>

        {/* TOGGLER */}
        <button className="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavbar">
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* NAV LINKS */}
        <div className="collapse navbar-collapse" id="mainNavbar">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <button className="nav-link btn btn-link border-0" onClick={() => scrollToSection("home")}>Home</button>
            </li>
            <li className="nav-item">
              <button className="nav-link btn btn-link border-0" onClick={() => scrollToSection("about")}>About</button>
            </li>
            <li className="nav-item">
              <button className="nav-link btn btn-link border-0" onClick={() => scrollToSection("features")}>Features</button>
            </li>
            <li className="nav-item">
              <button className="nav-link btn btn-link border-0" onClick={() => scrollToSection("specializations")}>Specializations</button>
            </li>
          </ul>

          <div className="d-flex gap-2">
            <button
              className="btn btn-light rounded-pill px-4 fw-bold d-flex align-items-center"
              onClick={() => navigate("/user/login")}
            >
              <i className="bi bi-person-fill me-2"></i> User
            </button>

            <button
              className="btn btn-outline-light rounded-pill px-4 fw-bold d-flex align-items-center"
              onClick={() => navigate("/doctor/login")}
            >
              <i className="bi bi-person-badge-fill me-2"></i> Doctor
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
